import View from "../../../Account/Js/views/NewslettersPreferencesView";
import components from "./components.js";
components.define("js-NewslettersPreferences", View);